import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroller';

import Chat from './chat';
import StartConversation from './startConversation';
import SearchedItem from './SearchedItem';
import PageTitle from '../../../components/pageTitle';
import Navigation from '../../../components/navigation';
import Search from '../../../components/searchField';

const Manage = ({
  t,
  searchMessage,
  messageCriteria,
  backgroundColor,
  backgroundCover,
  enableCoverColor,
  searchedData,
  setSearchMessage,
  loadMore,
  refs,
  getChannelName,
  startChatCallback,
  changeSearchCallback,
  defaultValueSearch,
  moduleTitle,
  searchedValue,
  callback,
}) => (
  <section className="Blog2 boxs knwldgeBase_D messages">
    <div className="container">
      <div className="Blog2inner boxs pdlr">
        <Navigation />
        <PageTitle
          title={moduleTitle}
          backgroundPage={backgroundColor}
          backgroundCover={backgroundCover}
          enableCoverColor={enableCoverColor}
        />
        <div className="middleKB middlemsg">
          <div className="middleinner boxs">
            <Search
              callbackToSetSearch={callback}
              placeholder={t('Search messages')}
              defaultValue={defaultValueSearch}
              changeSearchCallback={changeSearchCallback}
            />
            {searchedValue ?
              searchedData.count || !searchedData.hasLoaded ?
                <div className="search-msg-wr">
                  <div
                    ref={r => refs.store('listConv', r)}
                    className="search-msg-box forscroll2 forscrollmessage"
                  >
                    <InfiniteScroll
                      loadMore={loadMore}
                      hasMore={searchedData.hasMore}
                      pageStart={0}
                      useWindow={false}
                      initialLoad={false}
                      loader={<div className="loader" key={0}>{t('Loading')} ...</div>}
                    >
                      {
                        searchedData.data.map((msg, index) =>
                          (<SearchedItem
                            key={index}
                            item={msg}
                            startChatCallback={startChatCallback}
                            getChannelName={getChannelName}
                          />))
                      }
                    </InfiniteScroll>
                  </div>
                </div> :
                <div className="search-msg-wr">
                  <div
                    ref={r => refs.store('listConv', r)}
                    className="search-msg-box forscroll2 forscrollmessage"
                  >
                    {t('Nothing found')}
                  </div>
                </div> : ''}

            <Switch>
              <Route
                exact
                path="/messages/:id"
                render={prop => (<Chat
                  messageCriteria={messageCriteria}
                  searchMessage={searchMessage}
                  setSearchMessage={setSearchMessage}
                  {...prop}
                />)}
              />
              <Route
                render={prop => (
                  <div className="msgleftw empty-chat">
                    <p>{t('Noting found')}</p>
                  </div>)}
              />
              <Redirect from="*" to="/messages" />
            </Switch>
            <StartConversation backgroundColor={backgroundColor} />
          </div>
        </div>
      </div>
    </div>
  </section>
);

Manage.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Manage;



// WEBPACK FOOTER //
// ./src/views/modules/messages/Manage.jsx